import { render, staticRenderFns } from "./RootComment.vue?vue&type=template&id=7855e272&scoped=true&"
import script from "./RootComment.vue?vue&type=script&lang=js&"
export * from "./RootComment.vue?vue&type=script&lang=js&"
import style0 from "./RootComment.vue?vue&type=style&index=0&id=7855e272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855e272",
  null
  
)

export default component.exports